// extracted by mini-css-extract-plugin
export default {"SaucesList":"SaucesList_SaucesList__3-bOk","SaucesList__item":"SaucesList_SaucesList__item__gmC3B","SaucesList__item-check":"SaucesList_SaucesList__item-check__3OH90"};